/*
 *
 * Communication Preferences constants
 *
 */
export const BASE_ACTION_CONSTANT = 'app/CommunicationPreferences';
export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const GET_PREFERENCES = `${BASE_ACTION_CONSTANT}/GET_PREFERENCES`;
export const GET_PREFERENCES_URL = '/pg/developer-notifications';

export const POST_PREFERENCES = `${BASE_ACTION_CONSTANT}/POST_PREFERENCES`;
export const POST_PREFERENCES_URL = {
  url: '/pg/developer-notifications',
  method: 'POST',
};

export const POST_PREFERENCES_AND_VERIFY_URL = {
  url: '/pg/developer-notifications-email-verify',
  method: 'POST',
};

export const UPDATE_PREFERENCES = `${BASE_ACTION_CONSTANT}/UPDATE_PREFERENCES`;
export const UPDATE_PREFERENCES_URL = {
  url: '/pg/developer-notifications',
  method: 'PUT',
};

export const UPDATE_GROUP_PREFERENCES = `${BASE_ACTION_CONSTANT}/UPDATE_GROUP_PREFERENCES`;

export const UPDATE_SHOW_RECEPIENT_ADDED_SUCCESS_MODAL = `${BASE_ACTION_CONSTANT}/UPDATE_SHOW_RECEPIENT_ADDED_SUCCESS_MODAL`;

export const UPDATE_GROUP_PREFERENCES_URL = {
  url: '/pg/merchant-notification-config',
  method: 'PUT',
};

export const items = [
  {
    title: 'API Updates',
    key: 'API_UPDATES',
    text: 'Receive notifications about the latest API Updates',
    panes: [
      {
        key: 'EMAIL',
        menuItem: 'Email',
      },
      {
        key: 'SMS',
        menuItem: 'SMS',
      },
      {
        key: 'WHATSAPP',
        menuItem: 'Whatsapp',
      },
    ],
  },
  {
    title: 'Error Updates',
    key: 'REALTIME_API_ERROR_ALERT',
    text: 'Receive notifications about the API error and alerts',
    panes: [
      {
        key: 'EMAIL',
        menuItem: 'Email',
      },
      {
        key: 'SMS',
        menuItem: 'SMS',
      },
      {
        key: 'WHATSAPP',
        menuItem: 'Whatsapp',
      },
    ],
  },
  {
    title: 'SDK Updates',
    key: 'SDK_UPDATES',
    text: 'Receive notifications about the latest SDK Updates',
    panes: [
      {
        key: 'EMAIL',
        menuItem: 'Email',
      },
      {
        key: 'SMS',
        menuItem: 'SMS',
      },
      {
        key: 'WHATSAPP',
        menuItem: 'Whatsapp',
      },
    ],
  },
];
